import React, { Component } from "react";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { GoogleOAuthProvider } from '@react-oauth/google';

import configureAppStore from "./configuration/configureStore";
import Routes from "./routes";
import { configureAxiosDefaults, axiosResponse } from "./api/axios";

import "react-redux-toastr/lib/css/react-redux-toastr.min.css";
import "./resources/css/toast-overrides.css";

class App extends Component {
  render() {
    const appStore = configureAppStore({});
    configureAxiosDefaults();
    axiosResponse();
    return (
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || "775085189478-4hd622epppt8hl42ucbk9jrlufv6vbe4.apps.googleusercontent.com"}>
        <Provider store={appStore}>
          <div className="h-100">
            <ReduxToastr
              timeOut={5000}
              newestOnTop
              preventDuplicates
              position="top-right"
              transitionIn="fadeIn"
              transitionOut="fadeOut"
              progressBar
            />
            <Routes />
          </div>
        </Provider>
      </GoogleOAuthProvider>
    );
  }
}
export default App;
